module.exports = __webpack_public_path__ + "img/logo-vector.edb5adc9.svg";